module.exports = __webpack_public_path__ + "img/banner_tjx_gdtj.20d8bbf2.jpg";